export const EXPORT_VEHICLES_PDF_REQUEST = 'EXPORT_VEHICLES_PDF_REQUEST';
export const EXPORT_VEHICLES_PDF_SUCCESS = 'EXPORT_VEHICLES_PDF_SUCCESS';
export const EXPORT_VEHICLES_PDF_FAILURE = 'EXPORT_VEHICLES_PDF_FAILURE';

export const EXPORT_VEHICLES_EXCEL_REQUEST = 'EXPORT_VEHICLES_EXCEL_REQUEST';
export const EXPORT_VEHICLES_EXCEL_SUCCESS = 'EXPORT_VEHICLES_EXCEL_SUCCESS';
export const EXPORT_VEHICLES_EXCEL_FAILURE = 'EXPORT_VEHICLES_EXCEL_FAILURE';

export const exportVehiclesPDFRequest = (filters) => ({
    type: EXPORT_VEHICLES_PDF_REQUEST,
    payload: { filters }
});

export const exportVehiclesPDFSuccess = () => ({
    type: EXPORT_VEHICLES_PDF_SUCCESS
});

export const exportVehiclesPDFFailure = (error) => ({
    type: EXPORT_VEHICLES_PDF_FAILURE,
    payload: { error }
});

export const exportVehiclesExcelRequest = (filters) => ({
    type: EXPORT_VEHICLES_EXCEL_REQUEST,
    payload: { filters }
});

export const exportVehiclesExcelSuccess = () => ({
    type: EXPORT_VEHICLES_EXCEL_SUCCESS
});

export const exportVehiclesExcelFailure = (error) => ({
    type: EXPORT_VEHICLES_EXCEL_FAILURE,
    payload: { error }
});
